import { useId, useContext } from "react";
import { Typography } from "@mui/material";
import { getImgHostingUrl } from "../utilities";

import { motion } from "framer-motion";
import { categoriesTransition } from "../animation-variants";

import { typeOfProducts } from "../shared/ProductClassification/type-of-products";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { AppContext } from "../contextProviders/AppContext";
import { useGetImage } from "./customHooks";
import { useGetImages } from "../hooks/use-get-images";

export default function Category({
  item,
  theme,
  handleCategoryChange,
  selectedCategory,
}) {
  const { FEATURE_USE_PRODUCT_TYPE_CATEGORIES } = useContext(AppContext);
  const itemKey = useId();

  const isSelected = FEATURE_USE_PRODUCT_TYPE_CATEGORIES
    ? item.id.some((id) => selectedCategory.includes(id))
    : selectedCategory.includes(item.id);

  const { imagePath, loading } = useGetImages(item?.image);


  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      key={itemKey}
      variants={categoriesTransition}
      style={{
        minHeight: 90,
        minWidth: 90,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: 8,
        alignItems: "center",
        padding: 3,
      }}
    >
      <div
        onClick={() => handleCategoryChange(item.id)}
        style={{
          height: 70,
          width: 80,
          marginBottom: 10,
          borderRadius: 7,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
          scale: isSelected ? "1.1" : "1",
          //  selectedCategory === item.id ? theme.palette.primary.main : null,

          borderStyle: isSelected ? "solid" : null,
          borderWidth: 0,
          // borderColor: selectedCategory === item.id ? theme.palette.primary.main : null,
          transition: "200ms ease-in-out",
        }}
      >
        {!item.typeId && !item.image && (
          <LocalOfferIcon
            style={{
              fontSize: 40,
              color: isSelected
                ? theme.palette.primary.buttonText
                : theme.palette.primary.main,
            }}
          />
        )}
        {item.typeId && !item?.image && (
          <img
            alt=""
            src={getImgHostingUrl(
              typeOfProducts.find((type) => type?.id === item?.typeId)?.image
            )}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "scale-down",
              marginTop: 7,
              fontSize: 40,
              width: 110,
            }}
          />
        )}

        {imagePath && (
          <img
            alt=""
            src={imagePath}
            style={{
              width: 90,
              objectFit: "scale-down",
              maxWidth: "100%",
              maxHeight: "100%",
              display: loading ? "none" : "block",
            }}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          inlineSize: "95px",
          overflowWrap: "break-word",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: isSelected ? 15 : 13,
            fontWeight: isSelected ? 600 : 400,
            color: theme.palette.primary.mainText,
          }}
        >
          <CategoryName item={item} />
        </Typography>
      </div>
    </motion.div>
  );
}

function CategoryName({ item }) {
  const { language } = useContext(AppContext);

  if (language === "fi") {
    return item?.nameT?.[language] ?? item?.name;
  }
  if (language === "se") {
    return item?.nameT?.["sv"] ?? item?.name;
  }
  if (language === "en") {
    return item?.nameT?.[language] ?? item?.name;
  }

  return item.name;
}
